module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audit_log_icons/key-aaaaf6d031dac5c5d5415643b375fe16.svg";